// extracted by mini-css-extract-plugin
module.exports =  {"emptyState":"EmptyStatePrimitive-module__emptyState___RyFxr","title":"EmptyStatePrimitive-module__title___fXl1x","description":"EmptyStatePrimitive-module__description___XEyHm"};